<template>
	<div class="container">
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="来源管理" name="source">
				<DijiaNumberPoolSource />
			</el-tab-pane>
			<el-tab-pane label="套餐匹配" name="package">
				<DijiaNumberPoolPackage />
			</el-tab-pane>
			<el-tab-pane label="号码管理" name="number">
				<DijiaNumberPoolNumber />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import DijiaNumberPoolSource from './DijiaNumberPoolSource.vue';
	import DijiaNumberPoolPackage from './DijiaNumberPoolPackage.vue';
	import DijiaNumberPoolNumber from './DijiaNumberPoolNumber.vue';
	export default {
		name: 'DijiaNumberPool',
		components: {
			DijiaNumberPoolSource,
			DijiaNumberPoolPackage,
			DijiaNumberPoolNumber
		},
		data() {
			return {
				activeName: 'source'
			};
		},
		methods: {
			handleClick(tab, event) {
				this.activeName = tab.props.name;
			}
		}
	};
</script>

<style scoped>
	.custom-tabs-source .el-tabs__active-bar {
		background-color: #409EFF;
	}
	.custom-tabs-source .el-tabs__item.is-active {
		color: #409EFF;
	}
	.custom-tabs-package .el-tabs__active-bar {
		background-color: #67C23A;
	}
	.custom-tabs-package .el-tabs__item.is-active {
		color: #67C23A;
	}
	.custom-tabs-number .el-tabs__active-bar {
		background-color: #E6A23C;
	}
	.custom-tabs-number .el-tabs__item.is-active {
		color: #E6A23C;
	}
</style>
